(function(){
  angular
    .module('EdxCommonModule')
    .directive('edxTypeOfLearningIcon', function(){
      return {
        restrict: 'E',
        scope: {
          typeOfLearning: '=edxTypeOfLearning'
        },
        templateUrl: '/resources/components/common/type-of-learning/type-of-learning-icon.directive.html',
        controller: ['edxTypeOfLearning', TypeOfLearningController],
        controllerAs: 'vm',
        bindToController: true
      };
    });

  function TypeOfLearningController(TypeOfLearning) {
    var vm = this;

    var ROOT = '/resources/images/type-of-learning/';
    var images = {};
    images[TypeOfLearning.EARLY_SENSE_MAKING] = 'early-sense-making.png';
    images[TypeOfLearning.LOOKING_FOR_STRUCTURE] = 'looking-for-structure.png';
    images[TypeOfLearning.FLUENTLY_USING_STRUCTURES] = 'fluently-using-structures.png';

    vm.imagePath = imagePathForToL(vm.typeOfLearning);

    function imagePathForToL(tol) {
      if (images[tol]) {
        return ROOT + images[tol];
      } else {
        return undefined;
      }
    }
  }
})();